import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  navigate : any;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar
  ) {
    this.sideMenu();
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
  sideMenu()
  {
    this.navigate =
    [
      {
        title : "Home",
        url   : "/home",
        icon  : "home"
      },
      {
        title : "Blocco Note",
        url   : "/notes",
        icon  : "clipboard-outline"
      },
      {
        title : "Dove sono",
        url   : "/map",
        icon  : "location-outline"
      },
      {
        title : "Wordpress",
        url   : "/wp",
        icon  : "logo-wordpress"
      },
      {
        title : "Notizie",
        url   : "/notizie",
        icon  : "newspaper-outline"
      },
      {
        title : "Film",
        url   : "/movies",
        icon  : "videocam-outline"
      },
      {
        title : "Audio player",
        url   : "/a-player",
        icon  : "musical-notes-outline"
      },
      {
        title : "Video youtube",
        url   : "/v-player",
        icon  : "logo-youtube"
      },
      {
        title : "Meteo",
        url   : "/meteo",
        icon  : "partly-sunny-outline"
      },
      {
        title : "Calendario",
        url   : "/calendario",
        icon  : "calendar-outline"
      },
      {
        title : "Calcolatrice",
        url   : "/calcolatrice",
        icon  : "calculator-outline"
      },
      {
        title : "Contatti",
        url   : "/appointment",
        icon  : "people-outline"
      },
      {
        title : "Upload Immagini",
        url   : "/upload",
        icon  : "images-outline"
      },
      {
        title : "Editor Html",
        url   : "/notepad",
        icon  : "create-outline"
      },
      {
        title : "Login",
        url   : "/login",
        icon  : "key-outline"
      },
    ]
  }
}
